import type {
  OverarchingCollectionProduct,
  Product as CollectionProduct
} from '@features/product/components/Collection/Collection.types';
import type { Product as GlobalProduct } from '@features/product/typings';

type Product = GlobalProduct | CollectionProduct | OverarchingCollectionProduct | null;

type GalleryItem = {
  label?: string | null;
  image: {
    id: string;
  };
};

export const getCollectionProductImageId = (product: Product): string => {
  const images = (product?.mediaGallery?.items ?? []).filter(item => Object.hasOwn(item, 'label'));

  if (images.length === 0) {
    return '';
  }

  return (
    findImageIdByLabel('product color detail', images) ||
    findImageIdByLabel('Main Image', images) ||
    ''
  );
};

const findImageIdByLabel = (label: string, items: GalleryItem[]): string | undefined =>
  items.find(item => 'label' in item && item.label === label)?.image.id;
